import { render, staticRenderFns } from "./OrderSingleSummaryDiscounts.vue?vue&type=template&id=7f413fa0&"
import script from "./OrderSingleSummaryDiscounts.vue?vue&type=script&lang=js&"
export * from "./OrderSingleSummaryDiscounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports